import { render, staticRenderFns } from "./ForumThreadReactions.vue?vue&type=template&id=0508ee31&scoped=true"
import script from "./ForumThreadReactions.vue?vue&type=script&lang=js"
export * from "./ForumThreadReactions.vue?vue&type=script&lang=js"
import style0 from "./ForumThreadReactions.vue?vue&type=style&index=0&id=0508ee31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508ee31",
  null
  
)

export default component.exports